// extracted by css-extract-rspack-plugin
export default {"formatSelector":"ommJ1uB2w4hNzjTj"};